var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title_name"},[_vm._v(_vm._s(_vm.passTitleData.titleName))]),_c('div',{staticClass:"comment"},[_vm._v(_vm._s(_vm.passTitleData.commentTxt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }